<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="520" persistent>
    <v-card>
      <v-card-title class="text-h6 text-center pb-2" style="font-weight: 500;">舵机可用性校验</v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model.number="form.maxServoId"
              label="舵机ID (N)"
              type="number"
              min="0"
              density="compact"
              variant="outlined"
              hint="将对舵机 0 ~ N 同时执行"
              persistent-hint
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.interval"
              label="操作间隔 (ms)"
              type="number"
              min="0"
              density="compact"
              variant="outlined"
              hide-details
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.loopCount"
              label="循环次数"
              type="number"
              min="1"
              density="compact"
              variant="outlined"
              hide-details
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.angleA"
              label="测试绝对角度 A"
              type="number"
              density="compact"
              variant="outlined"
              hide-details
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.angleB"
              label="测试绝对角度 B"
              type="number"
              density="compact"
              variant="outlined"
              hide-details
            />
          </v-col>
        </v-row>
        <div class="text-caption text-grey mt-2">
          单次循环中，设备将在角度 A、B 间往返（对舵机 0 ~ N 同时下发），每次执行间隔 500ms。
        </div>
      </v-card-text>
      <v-card-actions class="pt-0 pb-3 pr-4">
        <v-spacer/>
        <v-btn variant="outlined" @click="$emit('update:modelValue', false)" :disabled="running">关闭</v-btn>
        <v-btn
          v-if="running"
          color="error"
          variant="outlined"
          @click="$emit('stop')"
        >停止</v-btn>
        <v-btn
          v-else
          color="primary"
          variant="outlined"
          prepend-icon="mdi-play"
          @click="$emit('run')"
        >运行可用性校验</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  form: { type: Object, required: true },
  running: { type: Boolean, default: false }
})
defineEmits(['update:modelValue', 'run', 'stop'])
</script>
